<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "app",
  components: {}
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100vh;
  background: #ecf0f3;
  position: relative;
}
.el-dialog__header {
  text-align: center;
  background: #ffffff;
}
.footer-title {
  text-align: center;
  font-size: 14px;
  color: #777777;
}
.ellipsis-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.word-warp {
  word-break: break-all;
  word-wrap: break-word;
}
.no-data {
  width: 100%;
  padding: 50px 0;
  text-align: center;
  color: #666666;
  font-size: 16px;
}
.el-message-box__wrapper {
  z-index: 9999 !important;
}
</style>
